import React, { Fragment } from 'react';

const Navigation = ({links=[], contentLink=null }) => {
    let menuRef = React.createRef();

    function toggleMenu() {
        menuRef.current.classList.toggle('navbar__menu--show');
        let w = window.innerWidth;
        let headerTop = document.querySelector('.header__top-links');
        let mobileMenu = document.querySelector('.navbar__menu-header');

        if(w < 1022) {
            mobileMenu.prepend(headerTop); 
           
        }
    }
    

    const additionClass = contentLink && contentLink.attributes ? contentLink.attributes.cssValue : null;
    const selectedClass = contentLink && contentLink.isSelected ? 'navbar__link--selected' : '';
    const hasChildrenClass = links.length > 0 ? 'has-children' : null;
    const hasNameOrChildren = link => link.name || (link.links || []).length > 0;

    return (
    <Fragment>
        {!contentLink ? (
            <a className="navbar__link--block navbar__icon--menu navbar__icon" onClick={toggleMenu}>
                <i className="icon ion-md-menu"></i>
            </a>
        ) : (
            <Fragment>
                <a className={`navbar__link ${selectedClass} ${hasChildrenClass || '' } ${additionClass || ''}`} 
                    href={contentLink.url||'#'} dangerouslySetInnerHTML={{__html: contentLink.name}} >
                </a>
                {links.length > 0 &&
                
                    <div className="navbar__icon--caret-right navbar__icon navbar__icon--open" onClick={toggleMenu}>
                        <i className="icon ion-md-arrow-dropright"></i>
                    </div>
                }
            </Fragment>
        )}

        { links.length > 0 &&
            <div className="navbar__menu" ref={menuRef} test={links.length}>
                <div className="navbar__menu-header">
                    {!contentLink ? (
                        <span className="navbar__icon navbar__icon--close" onClick={toggleMenu}>
                            <i className="icon ion-md-close"></i>
                        </span>
                    ) : (
                        <Fragment>
                            <div className="navbar__icon--caret-left navbar__icon" onClick={toggleMenu}>
                                <i className="icon ion-md-arrow-dropleft"></i>
                            </div>
                            <span className="navbar__title" onClick={toggleMenu} dangerouslySetInnerHTML={{__html: contentLink.name}}></span>
                        </Fragment>
                    )}
                </div>
                <ul className="nav-wrap">
                {links.length > 0 && links.map((link, i) => hasNameOrChildren(link) &&
                    <li className={link.extraInfo ? link.extraInfo : '' + 'navbar__item'} key={link.url}>
                        <Navigation links={link.links} contentLink={link}/>
                    </li>
                )}
                </ul>
            </div>
        }
        
    </Fragment>
)}

export default Navigation;